import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  () => ({
    root: {
      width: '100%',

      '&:after': {
        content: '""',
        display: 'block',
        // maxWidth: '100%',
        width: '100vw',
        position: 'absolute',
        bottom: '-100px',
        height: '100px',
        boxShadow: `
          0px -9px 11px -5px rgba(0,0,0,0.15),
          0px -18px 28px 2px rgba(0,0,0,0.105),
          0px -7px 34px 6px rgba(0,0,0,0.09);
        `,
        zIndex: 1,
      },
    },
    overlay: {
      transition: 'opacity 150ms linear',
      position: 'absolute',
      width: '100%',
      height: '100%',
      opacity: 0,
      bottom: 0,
      left: 0,
      zIndex: 2,
    },
  }),
  { name: 'GenHeroHomepageContentOverlay' },
);

export default useStyles;
